import React from 'react'
import { useTranslation } from 'react-i18next'
import useCopilotAccountOwnerId from 'components/CopilotControl/hooks/useCopilotAccountOwnerId'
import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import { isBriefCoverageComplete } from 'components/CopilotControl/patientBriefCoverageLogic'
import {
  useFetchPatientBriefCoverageQuery,
  useFetchPatientsMissingCopilotSettingsInfiniteQuery
} from 'store/modules/CopilotControl'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import PatientsList from '../../common/PatientsList/PatientsList'
import PatientListTitle from '../../common/PatientsList/PatientListTitle'
import PatientsListError from '../PatientsListError'
import MissingCopilotSettingsListItem from './MissingCopilotSettingsListItem'

const MissingCopilotSettingsList = () => {
  const { t } = useTranslation()
  const accountOwnerId = useCopilotAccountOwnerId()
  const { isStatusesLoading } = useCopilotPatientsList()
  const {
    currentData: coverage,
    isError: isCoverageError,
    isFetching: isCoverageFetching
  } = useFetchPatientBriefCoverageQuery({ accountOwnerId }, { skip: !accountOwnerId, refetchOnMountOrArgChange: true })
  const {
    currentData: data,
    isFetching,
    isError,
    hasNextPage,
    fetchNextPage
  } = useFetchPatientsMissingCopilotSettingsInfiniteQuery(
    { accountOwnerId },
    { skip: !accountOwnerId, pollingInterval: 30000, refetchOnMountOrArgChange: true }
  )
  const patients = data?.pages.flatMap(page => page.items) || []
  const coverageReady = isBriefCoverageComplete(coverage)
  const emptyState =
    isError || isCoverageError ? (
      <PatientsListError />
    ) : (
      <DazzedHeading14 regular style={{ padding: 20, textAlign: 'center' }}>
        {t(
          `pages.copilotControl.mainPage.copilotUtilization.${
            !coverageReady || coverage.patientsWithoutBrief > 0
              ? 'coverageUnavailable'
              : coverage.activePatients
              ? 'allPatientsConfigured'
              : 'noActivePatients'
          }`
        )}
      </DazzedHeading14>
    )

  return (
    <PatientsList
      isEmpty={!patients.length}
      isListLoading={!accountOwnerId || isStatusesLoading || (!data && isFetching) || (!coverage && isCoverageFetching)}
      fetchNextPage={fetchNextPage}
      hasMorePages={hasNextPage}
      patients={patients}
      EmptyStateComponent={emptyState}
      PatientsHeaderComponent={
        <>
          <PatientListTitle />
          {isError && patients.length > 0 && <PatientsListError />}
        </>
      }
      PatientListItemComponent={MissingCopilotSettingsListItem}
    />
  )
}

export default MissingCopilotSettingsList
